import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TCreateHelpRequest,
  THelpRequest,
  THelpRequestList,
  THelpRequestListParams,
  TResolveHelpRequest,
} from './help-requests.types.ts';

export const helpRequestsApi = {
  createRequest: async (request: TCreateHelpRequest) => {
    const response = await axios.post<THelpRequest>(`help-requests`, request);

    return response.data;
  },
  getMyRequests: async () => {
    const response = await axios.get<THelpRequest[]>(`help-requests/me`);

    return response.data;
  },
  // Admin
  getRequests: async (params: THelpRequestListParams = {}) => {
    const response = await axios.get<THelpRequestList>(`help-requests/admin`, { params });

    return response.data;
  },
  resolveRequest: async ({ id, admin_note }: TResolveHelpRequest) => {
    const response = await axios.patch<THelpRequest>(`help-requests/admin/${id}/resolve`, {
      admin_note,
    });

    return response.data;
  },
};

export const helpRequestsQueries = createQueryKeys('help-requests', {
  getMyRequests: () => ({
    queryKey: ['me'],
    queryFn: helpRequestsApi.getMyRequests,
  }),
  getRequests: (params: THelpRequestListParams = {}) => ({
    queryKey: [params],
    queryFn: () => helpRequestsApi.getRequests(params),
  }),
});
